import checkUndefinedOrNull from '../tools/checkUndefinedOrNull';

export default function formatText<T>(string: string, ...args): T {
    if (checkUndefinedOrNull(string)) {
        return null;
    }

    const returnArray = [];
    const match = string.match(/{([0-9]+)}/g);

    if (checkUndefinedOrNull(match)) {
        // @ts-ignore
        return string;
    }

    let stringOnly = true;
    for (let i = 0; i < match.length; i++) {
        const splitArray = string.split(match[i]);
        returnArray.push(splitArray[0]);
        returnArray.push(args[i]);
        string = string?.substring(string.indexOf(match[i]) + match[i].length);
        if (stringOnly && typeof args[i] !== 'string') {
            stringOnly = false;
        }
    }
    returnArray.push(string);
    // @ts-ignore
    return stringOnly ? returnArray.join('') : returnArray;
}
